import React from 'react';

const Footer = () => {
  return (
    <>
      {/* Responsible Gambling Notice */}
      <section className="py-8 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-gray-700 mb-4">
            <strong>Play Responsibly.</strong> Gambling should be fun and entertaining. 
            If you're concerned about your gambling, help is available.
          </p>
          <div className="space-x-4">
            <a 
              href="https://gambleaware.nsw.gov.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-yellow-600 underline hover:text-yellow-700"
            >
              GambleAware NSW
            </a>
            <a 
              href="https://betstop.gov.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-yellow-600 underline hover:text-yellow-700"
            >
              BetStop National Self-Exclusion
            </a>
          </div>
          <p className="text-gray-600 text-sm mt-2">Call 1800 858 858 for gambling help</p>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-8 bg-gray-200">
        <div className="max-w-6xl mx-auto px-4">
          <h3 className="text-center text-gray-700 font-medium mb-6">Our Trusted Partners</h3>
          <ul className="flex flex-wrap items-center justify-center gap-8">
            <li>
              <div className="p-4 rounded-lg shadow-sm">
                <img 
                  src="/images/18+.png" 
                  alt="Gaming Authority Partner"
                  className="h-12 w-auto object-contain"
                />
              </div>
            </li>
            <li>
              <a href="https://gamblershelp.com.au/" target="_blank" rel="noopener noreferrer">
                <div className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <img 
                    src="/images/GH.svg" 
                    alt="Gamblers Help"
                    className="h-12 w-auto object-contain"
                  />
                </div>
              </a>
            </li>
            <li>
              <a href="https://www.nsw.gov.au/" target="_blank" rel="noopener noreferrer">
                <div className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <img 
                    src="/images/NSW.svg" 
                    alt="NSW Government"
                    className="h-12 w-auto object-contain"
                  />
                </div>
              </a>
            </li>
            <li>
              <a href="https://resetapp.com.au/" target="_blank" rel="noopener noreferrer">
                <div className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <img 
                    src="/images/Reset.png" 
                    alt="Reset App"
                    className="h-12 w-auto object-contain"
                  />
                </div>
              </a>
            </li>
            <li>
              <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer">
                <div className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <img 
                    src="/images/GA.svg" 
                    alt="GambleAware"
                    className="h-12 w-auto object-contain"
                  />
                </div>
              </a>
            </li>
          </ul>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold text-yellow-500 mb-4">GoldenTicketLucky</h3>
              <p className="text-gray-300 text-sm">
                Dream big, play responsibly. Your trusted Australian lottery experience.
              </p>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Quick Links</h4>
              <div className="space-y-2 text-sm">
                <a href="/about" className="block text-gray-300 hover:text-yellow-500">About Us</a>
                <a href="/play" className="block text-gray-300 hover:text-yellow-500">Play Lottery</a>
                <a href="/results" className="block text-gray-300 hover:text-yellow-500">Draw Results</a>
                <a href="/contact" className="block text-gray-300 hover:text-yellow-500">Contact</a>
              </div>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Legal</h4>
              <div className="space-y-2 text-sm">
                <a href="/terms" className="block text-gray-300 hover:text-yellow-500">Terms & Conditions</a>
                <a href="/privacy" className="block text-gray-300 hover:text-yellow-500">Privacy Policy</a>
                <a href="/cookies" className="block text-gray-300 hover:text-yellow-500">Cookie Policy</a>
                <a href="/accessibility" className="block text-gray-300 hover:text-yellow-500">Accessibility</a>
              </div>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Get Help</h4>
              <div className="space-y-2 text-sm">
                <a href="https://gambleaware.nsw.gov.au" target="_blank" rel="noopener noreferrer" className="block text-gray-300 hover:text-yellow-500">GambleAware</a>
                <a href="https://betstop.gov.au" target="_blank" rel="noopener noreferrer" className="block text-gray-300 hover:text-yellow-500">BetStop</a>
                <p className="text-gray-300">+61 35 9294 105</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-300">
            <p>© 2025 GoldenTicketLucky. All rights reserved. | Licensed under NSW Lotteries Act | 18+ only</p>
            <p className="mt-2">
              BetStop — National Self-Exclusion Register. A free tool to opt out of online wagering. Visit{' '}
              <a href="https://betstop.gov.au" target="_blank" rel="noopener noreferrer" className="text-yellow-500 underline">
                betstop.gov.au
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
